// Texty spec chipů na kartě výpisu (specChips.js), slovenské dvojče.
// SK: párování `params` i `boolYes`/`boolNo` s indexem SK neověřeno (#71) —
// SK tenant hledání zatím neexistuje, názvy parametrů jsou překlad.
export default {
  yes: 'Áno',
  boolYes: 'áno',
  boolNo: 'nie',
  params: {
    prikon: 'Príkon',
    maxPrutok: 'Max. prietok',
    maxVytlak: 'Max. výtlak',
    vykonMotoru: 'Výkon motora',
    prikonVykon: 'Príkon / výkon',
    maxSaciHloubka: 'Max. sacia hĺbka',
    delkaListy: 'Dĺžka lišty',
    napeti: 'Napätie',
    kapacitaBaterie: 'Kapacita batérie',
    napetiBaterie: 'Napätie batérie',
    krouticiMoment: 'Krútiaci moment',
    prumerKotouce: 'Priemer kotúča',
    otackyNaprazdno: 'Otáčky naprázdno',
    vykon: 'Výkon',
    zdvihovyObjemMotoru: 'Zdvihový objem motora',
    postroj: 'Postroj',
    priklep: 'Príklep',
    upinani: 'Upínanie',
    energieUderu: 'Energia úderu',
    hmotnost: 'Hmotnosť',
    prumeryNastavcu: 'Priemery nástavcov',
    maxTeplota: 'Max. teplota',
    svarovaciProud: 'Zvárací prúd',
    prumerElektrody: 'Priemer elektródy',
    delkaKabelu: 'Dĺžka kábla',
    pocetZasuvek: 'Počet zásuviek',
    prurezVodice: 'Prierez vodiča',
    materialBubnu: 'Materiál bubna',
    pocetNastrojuVSade: 'Počet nástrojov v sade',
    pocetBaterii: 'Počet batérií',
    nosnost: 'Nosnosť',
    minVyska: 'Min. výška',
    objemNadobky: 'Objem nádobky',
    tahMagnetu: 'Ťah magnetu',
    zavitOka: 'Závit oka',
    taznaSilaNosnost: 'Ťažná sila / nosnosť',
    delka: 'Dĺžka',
    barva: 'Farba',
    vyska: 'Výška',
    pracovniSirka: 'Pracovná šírka',
    pracovniHloubka: 'Pracovná hĺbka',
    objemNadrze: 'Objem nádrže',
    prumerVentilatoru: 'Priemer ventilátora',
    pocetRychlosti: 'Počet rýchlostí',
    objemNadoby: 'Objem nádoby',
    saciVykon: 'Sací výkon',
    rozmery: 'Rozmery',
    objemVody: 'Objem vody',
    material: 'Materiál',
    teplotniRozsah: 'Teplotný rozsah',
    pocetPlotynek: 'Počet platničiek',
    objemKartuse: 'Objem kartuše',
    nabijeciNapeti: 'Nabíjacie napätie',
    nabijeciProud: 'Nabíjací prúd',
    rozsahKapacityBaterie: 'Rozsah kapacity batérie',
    maximalniNosnost: 'Maximálna nosnosť',
  },
};
